import Chart from "pro-features/components/Chart/src/Chart";
import { getChartConfig } from "app/pages/website-analysis/analyze-publishers/common/ads-traffic/AdsTrafficChartConfig";
import React from "react";
import styled from "styled-components";
import type { IAdsTrafficChartProps } from "./AdsTrafficTypes";
import { Legends } from "app/components/React/Legends/Legends";
import { LegendWithOneLineCheckboxFlex } from "@similarweb/ui-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { buildChartData } from "app/pages/website-analysis/analyze-publishers/common/ads-traffic/AdsTrafficChartParsers";
import { allTrackers } from "app/services/track/track";

const ChartLegendsContainer = styled(FlexColumn)`
    max-width: 300px;
    width: 25%;
    margin-left: 24px;
    @media print {
        width: 25%;
    }
`;

const CheckBoxContainer = styled(FlexColumn)`
    width: 100%;
    justify-content: center;
`;

const StyledLegendWrapper = styled.div`
    width: 100%;
    margin-bottom: 8px;
    .winnerIcon {
        padding-top: 0;
    }
`;

const StyledChartContainer = styled.div<{ isCompareMode: boolean }>`
    flex: 1;
    width: 75%;
`;

const AdsTrafficChart: React.FunctionComponent<IAdsTrafficChartProps> = ({
    chartRawData,
    legendItems,
    isCompareMode,
    afterRender,
}) => {
    const [legends, setLegends] = React.useState(legendItems);
    const filteredSites = legends.reduce((results, legend) => {
        if (legend.hidden) {
            results.push(legend.name);
        }
        return results;
    }, []);
    const chartData = buildChartData(chartRawData, filteredSites);
    const chartConfig = getChartConfig();
    const chartType = "line";

    const onLegendClick = (filter) => {
        const action = filter.hidden ? "add" : "remove";
        let isAllLegendsChecked = true;
        const filterLegends = legends.map((f) => {
            if (f.name === filter.name) {
                f.hidden = !f.hidden;
                f.visible = !f.visible;
            }
            if (f.hidden) {
                isAllLegendsChecked = false;
            }
            return f;
        });
        setLegends(filterLegends);
        allTrackers.dispatchTrackEvent(
            "Graph Filter",
            "click",
            `Analyze Publishers/Traffic Ads/Graph/${filter.name || ""}/${action || ""}/`,
        );
    };

    const renderLegends = () => {
        return (
            legends &&
            legends.length > 0 && (
                <Legends
                    legendComponent={LegendWithOneLineCheckboxFlex}
                    legendComponentWrapper={StyledLegendWrapper}
                    legendItems={legends}
                    toggleSeries={onLegendClick}
                    gridDirection="column"
                    textMaxWidth={window.innerWidth < 1680 ? (window.innerWidth > 1366 ? "125px" : "100px") : "150px"}
                />
            )
        );
    };

    return (
        <>
            <StyledChartContainer isCompareMode={isCompareMode}>
                <Chart
                    type={chartType}
                    data={chartData}
                    config={chartConfig}
                    afterRender={afterRender}
                />
            </StyledChartContainer>
            {isCompareMode && (
                <ChartLegendsContainer>
                    <CheckBoxContainer>{renderLegends()}</CheckBoxContainer>
                </ChartLegendsContainer>
            )}
        </>
    );
};

export default AdsTrafficChart;
